import type { SortByColumn, SortByColumnOrder } from "@/lib/states/global-state"

export interface SortableSearchThread {
	id: string
	lastMessageAt?: number | null
	painLevel?: string | null
	snoozedUntil?: number | null
}

interface Options<T> {
	items: readonly T[]
	getThread: (item: T) => SortableSearchThread
	column: SortByColumn
	order: SortByColumnOrder
	// Meili relevance position per thread id, used to break ties.
	rank?: Map<string, number>
}

export function sortSearchThreads<T>({
	items,
	getThread,
	column,
	order,
	rank,
}: Options<T>): T[] {
	const dir = order === "asc" ? 1 : -1

	return [...items].sort((a, b) => {
		const ta = getThread(a)
		const tb = getThread(b)
		const av = ta[column] ?? null
		const bv = tb[column] ?? null

		if (av !== bv) {
			if (av === null) return 1
			if (bv === null) return -1
			return av < bv ? -dir : dir
		}

		if (rank) {
			const ra = rank.get(ta.id) ?? Number.MAX_SAFE_INTEGER
			const rb = rank.get(tb.id) ?? Number.MAX_SAFE_INTEGER
			if (ra !== rb) return ra - rb
		}

		return ta.id < tb.id ? -dir : ta.id > tb.id ? dir : 0
	})
}
